export type VehicleDocumentType = 'crlv' | 'antt' | 'insurance' | 'license' | 'photo' | 'other';
export type DriverDocumentType = 'cnh' | 'cpf' | 'proof_of_address' | 'photo' | 'other';

export interface DocumentItem {
  id: string;
  type: string;
  description: string | null;
  issueDate: string | null;
  expiresAt: string | null;
  createdAt: string;
  upload: {
    id: string;
    filename: string;
    mimeType: string;
    sizeBytes: number;
    status: string;
    createdAt: string;
  };
}

export interface DocumentsListResponse {
  data: DocumentItem[];
}

export const VEHICLE_DOCUMENT_LABELS: Record<VehicleDocumentType, string> = {
  crlv: 'CRLV',
  antt: 'ANTT/RNTRC',
  insurance: 'Apólice de seguro',
  license: 'Licenciamento',
  photo: 'Foto do veículo',
  other: 'Outro',
};

export const DRIVER_DOCUMENT_LABELS: Record<DriverDocumentType, string> = {
  cnh: 'CNH',
  cpf: 'CPF',
  proof_of_address: 'Comprovante de endereço',
  photo: 'Foto',
  other: 'Outro',
};

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
